import { Alert, Space, Tag } from "antd";
import { dedupRunSummary } from "common/dedupRunSummary";
import React from "react";

interface IDeduplicationRunSummaryProps {
    runInfo: any;
}

// A deduplication job's counts (golden records merged, created, held, left...) and, when it could
// not finish or skipped clusters, what to do next.
const DeduplicationRunSummary = ({ runInfo }: IDeduplicationRunSummaryProps) => {
    const { counts, prompt } = dedupRunSummary(runInfo);
    if (counts.length === 0 && !prompt) {
        return null;
    }
    return (
        <Space orientation="vertical" size="small" data-testid="dedup-run-summary">
            {counts.length > 0 && (
                <Space wrap size={[4, 4]}>
                    {counts.map((count) => (
                        <Tag key={count.key} data-testid={`dedup-run-count-${count.key}`}>
                            {count.label}: {count.value}
                        </Tag>
                    ))}
                </Space>
            )}
            {prompt && <Alert type="warning" showIcon title={prompt} data-testid="dedup-run-prompt" />}
        </Space>
    );
};

export default DeduplicationRunSummary;
